import React from 'react';
import { BoxProps } from '@chakra-ui/react';
import { Text, Icon, IconNameEnum, Colors } from '@mercator-gcp/grout';
import { FlexRow } from 'components/layout/FlexRow';

const menuItemStyle = (isDisabled?: boolean) => ({
  justifyContent: 'flex-start',
  columnGap: 'padding_8',
  paddingX: 'padding_8',
  paddingY: 'padding_8',
  color: isDisabled ? Colors.TextQuiet : Colors.TextDefault,
  '&:hover': {
    background: Colors.ArmyGreen100,
    cursor: isDisabled ? 'default' : 'pointer',
  },
});

type TStyledMenuItemProps = {
  iconName?: IconNameEnum;
  label: string;
  onClick: React.MouseEventHandler<HTMLDivElement>;
  isDisabled?: boolean;
  sx?: BoxProps['sx'];
};

const Item = ({
  iconName,
  label,
  onClick,
  isDisabled,
  sx = {},
}: TStyledMenuItemProps) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isDisabled) {
      onClick(e);
    }
  };

  return (
    <FlexRow onClick={handleClick} sx={{ ...menuItemStyle(isDisabled), ...sx }}>
      {iconName && <Icon name={iconName} />}
      <Text>{label}</Text>
    </FlexRow>
  );
};

export default Item;
